// Aviso del cobro rechazado porque una promo no acepta el medio: cambiar el medio o quitar la promo.
import { useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/kit';
import { WizardWarningNotice } from './WizardWarningNotice';

export function PromotionPaymentNotice({
    sessionId,
    message,
}: {
    sessionId: string;
    message: string | undefined;
}) {
    const navigate = useNavigate();
    if (!message) return null;
    return (
        <WizardWarningNotice
            action={
                <Button
                    size="sm"
                    variant="secondary"
                    leftIcon={<ArrowLeft className="size-3.5" aria-hidden />}
                    onClick={() =>
                        void navigate({
                            to: '/wizard/s/$sessionId/$step',
                            params: { sessionId, step: 'build-sale' },
                        })
                    }
                >
                    Quitar la promo en Arma la venta
                </Button>
            }
        >
            {message}
        </WizardWarningNotice>
    );
}
